import { Info } from "lucide-react";

export const NOT_TAKING_OPTIONS = [
  ["sat_act", "I'm not taking the SAT or ACT"],
  ["english", "I'm not taking an English test (IELTS/TOEFL)"],
];

// Declares tests the student won't sit, with an honest notice about what it changes.
export function TestsNotTakingField({ value, onChange }) {
  const set = new Set(Array.isArray(value) ? value : []);
  const toggle = (k) => {
    const next = new Set(set);
    if (next.has(k)) next.delete(k); else next.add(k);
    onChange(NOT_TAKING_OPTIONS.map(([o]) => o).filter((o) => next.has(o)));
  };
  return (
    <fieldset className="sm:col-span-2" data-testid="profile-tests-not-taking">
      <legend className="text-[12px] font-medium text-stone-700 mb-1">Tests I'm not taking</legend>
      <div className="space-y-1.5">
        {NOT_TAKING_OPTIONS.map(([k, label]) => (
          <label key={k} className="flex items-center gap-2 text-[13px] text-stone-800">
            <input type="checkbox" checked={set.has(k)} onChange={() => toggle(k)} data-testid={`profile-not-taking-${k}`} />
            {label}
          </label>
        ))}
      </div>
      <p className="mt-2 flex gap-2 rounded-md bg-amber-50 border border-amber-200 p-2 text-[12px] text-amber-900 leading-snug" data-testid="profile-not-taking-notice">
        <Info className="h-4 w-4 shrink-0 mt-0.5" aria-hidden="true" />
        <span>
          This changes your scores: the test is left out of your grade gap and its weight is shared across your other answers,
          so courses can move up or down. Where a university requires the test, it still counts as missing.
          If you might take it, or want the most realistic picture for universities that prefer it (many US universities do for SAT/ACT),
          leave this unticked.
        </span>
      </p>
    </fieldset>
  );
}
